export const currentAnimationsSelector = (state) => state.animations.current;
